import { OnboardingLocalStorageKeys } from '~/pages/Onboarding/onboarding.constants';
import type { Onboarding2024PlanType, Onboarding204RouteType } from '../types';
import {
  ONBOARDING_2024_CURRENT_STEP,
  ONBOARDING_2024_FLAG_STORAGE,
  ONBOARDING_2024_IN_PROGRESS,
  ONBOARDING_2024_MONTHLY_VOLUME,
  ONBOARDING_2024_SELECTED_PLAN,
} from './constants';

export const setOnboarding2024InProgress = (value: boolean) => {
  localStorage.setItem(ONBOARDING_2024_IN_PROGRESS, value.toString());
};

export const getOnboarding2024InProgress = (): boolean => {
  return localStorage.getItem(ONBOARDING_2024_IN_PROGRESS) === 'true';
};

export const setOnboarding2024CurrentStep = (value: Onboarding204RouteType) => {
  localStorage.setItem(ONBOARDING_2024_CURRENT_STEP, value.toString());
};

export const getOnboarding2024CurrentStep = (): Onboarding204RouteType => {
  return localStorage.getItem(ONBOARDING_2024_CURRENT_STEP) as Onboarding204RouteType;
};

export const setOnboarding2024SelectedPlan = (value: Onboarding2024PlanType) => {
  localStorage.setItem(ONBOARDING_2024_SELECTED_PLAN, value);
};

export const removeOnboarding2024SelectedPlan = () => {
  localStorage.removeItem(ONBOARDING_2024_SELECTED_PLAN);
};

export const getOnboarding2024SelectedPlan = (): Onboarding2024PlanType => {
  return localStorage.getItem(ONBOARDING_2024_SELECTED_PLAN) as Onboarding2024PlanType;
};

export const clearOldOnboardingLocalStorage = () => {
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_LAST_COMPLETED_STEP);
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_CURRENT_STEP);
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_ACTIVE);
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_BUSINESS_TYPE);
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_BUSINESS_NEED);
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_SHOW_WELCOME_MESSAGE);
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_ORDER_MECHANISM);
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_ACTIVE_STORE);
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_USER_COUNTRY);
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_COMPLETED);
};

export const clearOnboarding2024LocalStorage = () => {
  clearOldOnboardingLocalStorage();
  localStorage.removeItem(ONBOARDING_2024_IN_PROGRESS);
  localStorage.removeItem(ONBOARDING_2024_CURRENT_STEP);
  localStorage.removeItem(ONBOARDING_2024_FLAG_STORAGE);
  removeOnboarding2024SelectedPlan();
};

export const setOnboarding2024FlagStorage = (value: boolean) => {
  localStorage.setItem(ONBOARDING_2024_FLAG_STORAGE, value.toString());
};

export const getOnboarding2024FlagStorage = (): string | null => {
  return localStorage.getItem(ONBOARDING_2024_FLAG_STORAGE);
};

export const setOnboarding2024MonthlyVolume = (value: string) => {
  localStorage.setItem(ONBOARDING_2024_MONTHLY_VOLUME, value);
};

export const getOnboarding2024MonthlyVolume = (): string => {
  return localStorage.getItem(ONBOARDING_2024_MONTHLY_VOLUME) || '';
};
